/**
 * THE WORDS FOR AN ELEMENT RULE'S REFUSALS (KPR-526; keepr-api docs/SCHEMA.md
 * § Element grants, "Writes"). The API holds the rules; this is the sentence
 * the person reads.
 *
 *   400 element_read_only { element, reason: 'grant' }   a save changed an
 *       element the person can see but not edit
 *   409 move_would_expose  failures: [{ itemId, code, elements?, restricted? }]
 *       a move would put a value where fewer rules protect it. `elements`
 *       names the ones the mover can see; `restricted` counts the others,
 *       which are never named.
 */

export const GRANT_READ_ONLY_WORDS = 'Only some people can change this.';

/** The 400 `element_read_only` a rule gave (`reason: 'grant'`), or false. */
export const isGrantReadOnly = data => !!data && typeof data === 'object'
	&& data.code === 'element_read_only' && data.reason === 'grant';

/** The element the refusal names, or ''. */
export const grantReadOnlyElement = data => (typeof data?.element === 'string' ? data.element : '');

/** "Salary", "Salary and Notes", "Salary, Notes and Dept". */
function listOf(names) {
	if (names.length < 2) return names[0] || '';
	return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

const MANAGER_STEP = 'ask a manager to set the same element access in the collection it would go to first';

/** Why a move would expose a record's values, in words (never guessing at `restricted` ones). */
export function moveWouldExposeWords(failure = {}) {
	const names = (Array.isArray(failure.elements) ? failure.elements : [])
		.filter(name => typeof name === 'string' && name.trim()).map(name => name.trim());
	const hidden = Math.max(0, Math.floor(Number(failure.restricted) || 0));
	const hiddenWords = hidden ? `${hidden.toLocaleString('en-US')} element${hidden === 1 ? '' : 's'} you cannot see` : '';
	if (!names.length && !hiddenWords) {
		return `it holds values that more people could see there — ${MANAGER_STEP}`;
	}
	const what = [names.length ? listOf(names) : '', hiddenWords].filter(Boolean).join(' and ');
	return `it holds ${what}, and fewer element rules protect ${names.length + hidden === 1 ? 'it' : 'them'} there — ${MANAGER_STEP}`;
}
